import { Box, Stack, Typography, Button, Chip } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import useLocalization from "../../hooks/useLocalization";

const CallItem = ({ call, onView }) => {
  const language = useSelector((state) => state.authentication.language);
  const isFrench = String(language || "")
    .toLowerCase()
    .startsWith("fr");
  const { getLabel } = useLocalization();

  const getLocalizedName = (entity, fallbackName, fallbackFrenchName) => {
    const defaultName = fallbackName || "";
    if (!entity || typeof entity !== "object") {
      return isFrench
        ? fallbackFrenchName || defaultName
        : defaultName || fallbackFrenchName || "";
    }

    if (isFrench) {
      return (
        entity.name_fr || fallbackFrenchName || entity.name || defaultName || ""
      );
    }

    return (
      entity.name || defaultName || entity.name_fr || fallbackFrenchName || ""
    );
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "complete":
        return "#4caf50";
      case "incomplete":
        return "#f44336";
      default:
        return "#9e9e9e";
    }
  };

  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 1,
      }}
    >
      {/* Left: Main Info */}
      <Stack sx={{ flex: 1, gap: 0.5 }}>
        {/* Project Name */}
        <Typography
          variant="body2"
          sx={{ fontWeight: 600 }}
        >
          {getLocalizedName(
            call.project,
            call.projectName,
            call.projectName_fr,
          ) || `${getLabel("unknown")} ${getLabel("project")}`}
        </Typography>

        {/* Project Dates */}
        {(call.projectStartDate || call.projectEndDate) && (
          <Typography
            variant="caption"
            sx={{ color: "#999" }}
          >
            {call.projectStartDate &&
              format(new Date(call.projectStartDate), "MMM d")}
            {call.projectStartDate && call.projectEndDate && " - "}
            {call.projectEndDate &&
              format(new Date(call.projectEndDate), "MMM d")}
          </Typography>
        )}
      </Stack>

      {/* Center: Duration & Status */}
      <Stack sx={{ alignItems: "flex-end", gap: 0.5 }}>
        {call.callDuration && (
          <Typography
            variant="caption"
            sx={{ color: "#666" }}
          >
            {call.callDuration} min
          </Typography>
        )}

        {/* Status Chip */}
        <Chip
          label={call.callStatus || "unknown"}
          size="small"
          sx={{
            backgroundColor: getStatusColor(call.callStatus),
            color: "white",
            textTransform: "capitalize",
            fontSize: "0.75rem",
          }}
        />
      </Stack>

      {/* Right: View Button */}
      <Button
        size="small"
        variant="text"
        onClick={() => onView(call)}
        sx={{ minWidth: "auto", padding: 0.5 }}
      >
        <OpenInNewIcon sx={{ fontSize: "1.25rem" }} />
      </Button>
    </Box>
  );
};

export default CallItem;
